<template>
    <div class="relative p-[1px] border-2 rounded-full cursor-pointer size-4 border-primary">
        <transition name="fade">
            <span v-if="inputValue == value" class="block w-full h-full rounded-full bg-primary"/>
        </transition>
        <input v-model="inputValue" type="radio" :name="name" :value="value" class="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer" >
    </div>
</template>

<script setup lang="ts">
const inputValue = defineModel<string>();

defineProps<{ name: string, value: string }>()
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s ease-in-out;
}
</style>